import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import { twMerge } from 'tailwind-merge';
import { TagKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    onClickRemove: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        tagKey: string,
    ) => void;
    text: string;
    tagKey: TagKey;
    shouldDisplayRemovalButton?: boolean;
    disabled?: boolean;
}

const TagRemovable = ({
    onClickRemove,
    text,
    tagKey,
    shouldDisplayRemovalButton = true,
    disabled = false,
}: Props) => {
    const { i18next } = useAppContext();
    return (
        <div
            className={twMerge(
                'darken-5 dark:darken-25 flex h-6 max-w-xs items-center justify-evenly rounded-md bg-gray-200 ps-2 pe-1 text-xs text-black',
                shouldDisplayRemovalButton ? '' : 'pe-2',
                disabled ? 'text-gray-500' : '',
            )}
        >
            {text}
            {shouldDisplayRemovalButton ? (
                <button
                    aria-label={i18next.t('remove')}
                    className={twMerge(
                        'hover:darken-10 ms-1 size-4 rounded-xl',
                        disabled
                            ? 'hover:cursor-default'
                            : 'hover:cursor-pointer',
                    )}
                    onClick={(event) => onClickRemove(event, tagKey)}
                    key={tagKey}
                    disabled={disabled}
                >
                    <Icon
                        size="0.75rem"
                        className={disabled ? 'text-gray-500' : 'text-gray-800'}
                        iconKey="close"
                    />
                </button>
            ) : null}
        </div>
    );
};

export default TagRemovable;
